import React, { useState, useEffect } from "react";
import Select from "react-select";
import Header from "./Header";
import "./css/PaymentForm.css";
import { useRef } from "react";
import jsPDF from "jspdf";
import { API_BASE_URL, ResidentGetAPIEndpoint, PaymentAddAPIEndPoint } from '../constant';
//import {datetimeFormat} from "../utils/common";

const flatOptions = [
  { value: "A-101", label: "A-101" },
  { value: "A-102", label: "A-102" },
  { value: "B-201", label: "B-201" },
];

const typeOptions = [
  { value: "cash", label: "Cash" },
  { value: "upi", label: "UPI" },
  { value: "bank", label: "Bank Transfer" },
];

const purposeOptions = [
  { value: "maintenance", label: "Maintenance" },
  { value: "parking", label: "Parking" },
  { value: "event", label: "Event" },
  { value: "other", label: "Other" },
];


export default function PaymentForm() {
  const token = sessionStorage.getItem("JWTtoken");
  const [form, setForm] = useState({
    flat: null,
    amount: "",
    type: "",
    date: "",
    bankName : "",
    branchName : "",
    chequeNo : "",
    refNo: "",
    purpose: "",
    desc: "",
    receiptNo : ""
  });

   useEffect(() => {
    GetOptionFlats();
  }, []);

  const [isListVisible, setIsListVisible] = useState(true);
  const [paymentId, setPaymentId] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 4; 


const [flatNumbers, setFlatNumbers] = useState([]);

const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;

const [paymentList, setPaymentList] = useState([]);

const currentRecords = paymentList.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(paymentList.length / recordsPerPage);


const [pdfData, setPdfData] = useState({});


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setForm({ ...form, amount: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    const userID = sessionStorage.getItem("userId");

    if (!form.flat || !form.amount || !form.type || !form.date) {
      alert("Please fill all required fields");
      return;
    }
    if(form.purpose === "other" && !form.desc)
    {
      alert("Please fill the description field for other purposes.");
      return;
    }

    const payload = {
      ...form,
      flat: form.flat.value,
      flatNumber: form.flat.label,
      amount: parseFloat(form.amount),
      createdby: userID,
      flatNo:123, //change it to the current logged in user flat no.
      bankName : form.bankName,
      branchName : form.branchName,
      chequeNo : form.chequeNo,
      receiptNo : form.receiptNo
    };

    //console.log("SUBMIT DATA:", payload);
     //console.log("SUBMIT DATA2:", form);
    // API CALL HERE
    paymentList.push(payload);
    const addApiURL = API_BASE_URL + PaymentAddAPIEndPoint;
    try{
      const response = await fetch(addApiURL,
      {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
      }
    );
    
      const result = await response.json();
      console.log(JSON.stringify(result));
      if (result.status) 
      {
        alert("Payment added successfully.");
        setIsListVisible(true); // Refresh the notices list
        setForm({
          flat: null,
          amount: "",
          type: "",
          date: "",
          bankName : "",
          branchName : "",
          chequeNo : "",
          refNo: "",
          purpose: "",
          desc: "",
          receiptNo : ""
        });
      }
      else{
        alert(result.message);  
      }
    }catch(err)
    {
      alert("Server error " . err)
    }
      
      
    
    
  };


const Edit = async(data)=>{
//alert("Edit => " + JSON.stringify(data));
setPaymentId(1);
const selectedFlat = flatOptions.find(
      (f) => f.value === data.flat
    );

setForm({ flat: selectedFlat, 
    amount: data.amount,
    type: data.type,
    date: data.date,
    bankName : data.bankName, 
    branchName : data.branchName,
    chequeNo : data.chequeNo,
    refNo : data.refNo,    
    purpose: data.purpose,    
    desc: data.desc,
    receiptNo : data.receiptNo
 });
 setIsListVisible(false);
}

const Delete = async(data)=>{
    

//alert("delete => " + JSON.stringify(data));

if (!window.confirm(`Are you sure to delete this ${data.flat} payment of ${data.purpose}?`)) return;



}



const openAdd = ()=>
{
    setIsListVisible(false);
     setForm({
    flat: null,
    amount: "",
    type: "",
    date: "",
    bankName : "",
    branchName : "",
    refNo: "",
    purpose: "",
    desc: "",
    receiptNo: ""
  });
  setPaymentId(0);
}

 const pdfRef = useRef();

const GeneratePDF = async(data) => {
  setPdfData({});

  data.receiptNo = await getReceiptNo(data);
  
  setPdfData(data);
  
  //alert(JSON.stringify(data));
  console.log("pdf data => " + JSON.stringify(pdfData));

  
     const doc = new jsPDF("p", "mm", "a4");
const {
    flat,
    amount,
    type,
    date,
    bankName,
    branchNamechequeNo,
    refNo,
    purpose,
    desc,
    flatNo,
    flatNumber
  } = data;

    var htmlContent = document.querySelector('#invoice-template');

doc.html(pdfRef.current, {
      x: 10,
      y: 10,
      width: 190,
      windowWidth: 900,
      callback: function (doc) {
        let date = new Date();
        let month = date.getMonth() + 1;
        /* Date format you have */
        let dateMDY = `${('0' + date.getDate()).slice(-2)}-${('0' + month).slice(-2)}-${date.getFullYear()} - ${('0' +date.getHours()).slice(-2)}-${('0' +date.getMinutes()).slice(-2)}-${('0' +date.getSeconds()).slice(-2)}`;
        /* Date converted to MM-DD-YYYY format */

        //const currentDate = new Date();
        //const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        //const formattedDate = currentDate.toLocaleDateString('en-US', options);
        //doc.save(data.flatNumber + " - "+ formattedDate + " - maintenance_receipt.pdf");

        doc.save(data.flatNumber + " - "+ dateMDY + " - maintenance_receipt.pdf");
      }
    });
}


  // Function to extract specific values
  const extractNameAndAge = (person) => {
    // Use object destructuring to pick the specific properties
    //const { id, apartment } = person;

    const payload = {
      value: person.id,
      label : person.apartment
    }
    // Return them as an array (or a new object if you prefer an array of objects)
    return payload;
  };



  const getReceiptNo = async(data) =>{
    let receiptNo = "RCPT" + new Date().getTime(); // Default receipt number if any error occurs
    try { 
      let buildingType = data.flatNumber.substring(0,1);
      let flatNumber = data.flatNumber.substring(2,data.flatNumber.length);
      let date = new Date();
      let month = date.getMonth() + 1;
      let fullYear = date.getFullYear();
      // let receiptNo = "RCPT" + fullYear + buildingType + flatNumber + month + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds();
      receiptNo = "RCPT" + fullYear + buildingType + flatNumber + ( '0' + month ).slice(-2)+ "001"; //001 replace with sequence number generator logic if needed. For now its static as there is no backend integration for payments.


    }
    catch (err) {
        alert("Some error occurred " + err);
      }  
    return receiptNo;
  }

 



const totalCount=0;


const GetOptionFlats= async()=>{
setFlatNumbers([]);
  try {
        const apiURL = API_BASE_URL + ResidentGetAPIEndpoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const res = await response.json();
        
        if (res.status) {
           const options = res.data.map(item => ({
        value: item.id,
        label: item.apartment
        }));
        setFlatNumbers(options);        

          //setUsers(res.data);
        } else {
          alert(res.message + "Failed to fetch users");
        }

      } catch (err) {
        alert("Server error " + err);
      }  
       
}




  return (<>

<Header/>

   {
    isListVisible && 
    <div>
        <h2> Payment Details <button 
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => openAdd()}
                >
                  Add
                </button>  
        </h2>
    <table>
        <thead>
          <tr>
            <th>Flat</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Type</th>
            <th>Purpose</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>          
          {
            currentRecords.length > 0 ? (
            currentRecords.map((data) => (
            <tr key={1}>
              <td>{data.flatNumber}</td>
              <td>{data.date}</td>
              <td>
                {data.amount}
              </td>
              <td> {data.type}</td>
              <td>{data.purpose}</td>  
              <td> 
                 { <button
                  className="btn-approve"
                  onClick={() => Edit(data)}
                >
                  Edit
                </button> }

                {<button
                
                  className="btn-reject"
                  onClick={() => Delete(data)}
                   //onClick={() => setRejectId(data.id)} 
                style={{ marginLeft: "6px" }}
                >
                  Delete
                </button>}
                { <button
                  className="btn-approve"
                  onClick={() => GeneratePDF(data)}
                >
                  DownloadPDF
                </button>}

              </td>
              
            </tr>
          ))
          ) : (
            <tr>
              <td colSpan="6" align="center">No records found</td>
            </tr>
          )}
        </tbody>
      </table>


<div  style={{display:"none"}}>  
    
    

        <div class="container" ref={pdfRef} style={{ padding: 20, width: "900px" }}>

    <table class="bordered-table" >
          <tr>
            <table>
              <tr>
                <td style={{width:"30%"}} rowspan="3"><img src="/KananLogo.png" style={{width:"210px", Height:"110px"}}/>  </td>
                <td style={{width:"70%"}} style={{ "font-size": "xx-large", color: "red",  "font-weight": "bold" }}> <center> Kanan Residency </center> </td>
              </tr>
              <tr>        
                <td style={{"font-size": "medium",  "font-weight": "bold"}}> <center>Behind Shreeji Sky, Nr. Shyam 42, Opp. Lambha Temple, Laxmipura, Lambha, Ahmedabad, Gujarat, India - 382440 </center></td>
              </tr>
              <tr>
                <td style={{textAlign:"right", "font-size": "medium",  "font-weight": "bold" }}> Reg.No. REG / AHD / SA (HA) - 22313</td>
              </tr>
            </table>
          </tr>
          <hr/>
          <tr>
            <table >
              <tr>
                  <td colspan="3" style={{"font-size": "medium",  "font-weight": "bold"}}> <center> <u>Receipt</u> </center></td>
              </tr>
              
              <tr>
                <td style={{"font-size": "medium",  "font-weight": "bold"}}>Rec No.: &nbsp;&nbsp;&nbsp;<u> {pdfData.receiptNo}</u></td>
                <td>&nbsp;</td>
                <td style={{ textAlign:"right", "font-size": "medium",  "font-weight": "bold"}}>Date.: &nbsp;&nbsp;&nbsp;<u>{pdfData.date}</u> &nbsp;&nbsp;&nbsp;</td>
              </tr>
              <tr>
                <td colSpan="2" style={{"font-size": "medium",  "font-weight": "bold"}}>Name.: &nbsp;&nbsp;&nbsp;<u>Manjit Bharatkumar Vaghadiya</u> </td>
                <td style={{textAlign:"right", "font-size": "medium",  "font-weight": "bold"}}>Shop / Flat No.: &nbsp;&nbsp;&nbsp;<u> {pdfData.flatNumber} </u>  &nbsp;&nbsp;&nbsp;</td> 
              </tr>
              { 1 == 2 && <tr>
                <td colSpan="2" style={{textAlign:"right", "font-size": "medium",  "font-weight": "bold"}}>&nbsp;</td> 
                <td style={{textAlign:"right", "font-size": "medium",  "font-weight": "bold"}}>Shop / Flat No.: &nbsp;&nbsp;&nbsp;<u> {pdfData.flatNumber} </u>  &nbsp;&nbsp;&nbsp;</td> 
              </tr>}
            </table>
          </tr>
          <hr/>
          <tr>
              <table>
                <tr>
                  <td style={{"font-size": "medium",  "font-weight": "bold"}}> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This is to formally acknowledge the receipt of payment against the details mentioned below. The said amount has been duly received and recorded in the society accounts.</td>
                </tr>
              </table>
          </tr> 
          <tr >
            <table>
              <tr>
                <td> <div style={{align:"60%"}} > 
                   <table border="1">
                    <tr><td style={{"font-size": "medium",  "font-weight": "bold"}}>Desc</td><td style={{"font-size": "medium",  "font-weight": "bold"}}>Amount</td></tr>
                    { pdfData.purpose === "maintenance" && <tr><td>Maintenance</td><td> <u>&nbsp;&nbsp;&nbsp; {pdfData.amount} &nbsp;&nbsp;&nbsp;</u> </td></tr> }
                    { pdfData.purpose === "parking" && <tr><td>Parking</td><td><u>&nbsp;&nbsp;&nbsp; {pdfData.amount} &nbsp;&nbsp;&nbsp;</u></td></tr>}
                    { pdfData.purpose === "event" && <tr><td>Event</td><td><u>&nbsp;&nbsp;&nbsp; {pdfData.amount} &nbsp;&nbsp;&nbsp;</u></td></tr>}
                    { pdfData.purpose === "other" && <tr><td>Other</td><td><u>&nbsp;&nbsp;&nbsp; {pdfData.amount} &nbsp;&nbsp;&nbsp;</u> </td></tr>}
                    { pdfData.purpose === "other" && <tr><td>Description</td><td><u>&nbsp;&nbsp;&nbsp; {pdfData.desc} &nbsp;&nbsp;&nbsp;</u></td></tr>}
                    { 1== 2 && <tr><td>Transfer Fees</td><td><u>&nbsp;&nbsp;&nbsp; {pdfData.amount} &nbsp;&nbsp;&nbsp;</u></td></tr>}
                    { 1== 2 && <tr><td>Rental income</td><td><u>&nbsp;&nbsp;&nbsp; {pdfData.amount} &nbsp;&nbsp;&nbsp;</u></td></tr>}
                    { 1== 2 && <tr><td>Other</td><td><u>&nbsp;&nbsp;&nbsp; {pdfData.amount} &nbsp;&nbsp;&nbsp;</u></td></tr>}
                  </table> </div>
                </td>
                <td style={{paddingLeft:"20px", paddingRight:"20px"}}> 
                  <center> Payment Mode.: <u style={{ textTransform: 'capitalize' }}>&nbsp;&nbsp;&nbsp; {pdfData.type}    &nbsp;&nbsp;&nbsp;</u><br/><br/>
                      Date.: <u>&nbsp;&nbsp;&nbsp; {pdfData.date} &nbsp;&nbsp;&nbsp;</u> <br/><br/>
                      { pdfData.type === "online" && <u> Ref No.: &nbsp;&nbsp;&nbsp; {pdfData.refNo} &nbsp;&nbsp;&nbsp;</u>}
                      { pdfData.type === "bank" && <u> Bank.: &nbsp;&nbsp;&nbsp; {pdfData.bankName} &nbsp;&nbsp;&nbsp;</u> } <br/><br/>
                      { pdfData.type === "bank" && <u>Branch.: &nbsp;&nbsp;&nbsp; {pdfData.branchName} &nbsp;&nbsp;&nbsp;</u> }<br/><br/>
                      { pdfData.type === "bank" && <u> Cheque No.: &nbsp;&nbsp;&nbsp; {pdfData.chequeNo} &nbsp;&nbsp;&nbsp;</u> } <br/><br/>
                      </center>
                </td>
              </tr>
            </table>
          </tr>
          <tr>
            <table>
              <tr>
                <td style={{textAlign:"right"}}> Chairman / Secretary</td>                
              </tr>
              <tr>
                <td style={{textAlign:"right", paddingRight:"50px"}}> <img src="/Parthkhatrisignature.png" style={{width:"210px", Height:"110px"}}/><br/>Signtature</td>
                </tr>
            </table>

          </tr>
          <tr>
            <td style={{textAlign:"center"}}> This is computer generated receipt and requires no signature.</td>
          </tr>
    </table>
 
  {1==2 && <div class="boxsdfsd">
    <table>
      <tr>
        <td style={{width:"30%"}} rowspan="3"><img src="/KananLogo.png" style={{width:"210px", Height:"110px"}}/>  </td>
        <td style={{width:"70%"}} style={{ "font-size": "xx-large", color: "red",  "font-weight": "bold" }}> <center> Kanan Residency </center> </td>
      </tr>
      <tr>        
        <td style={{"font-size": "medium",  "font-weight": "bold"}}> <center>Behind Shreeji Sky, Nr. Shyam 42, Opp. Lambha Temple, Laxmipura, Lambha, Ahmedabad, Gujarat, India - 382440 </center></td>
      </tr>
      <tr>
        <td style={{textAlign:"right", "font-size": "medium",  "font-weight": "bold" }}> Reg.No. REG/AHD/SA(HA)-22313</td>
      </tr>
    </table>
  </div>}

  
  {1==2 && <div class="boxdfdgf">
    <table border="0">
        <tr>
            <td colspan="3" style={{"font-size": "medium",  "font-weight": "bold"}}> <center> Receipt </center></td>
        </tr>
      <tr>
        <td style={{"font-size": "medium",  "font-weight": "bold"}}>Rec No.: &nbsp;&nbsp;&nbsp;<u> RCPT2000010125</u></td>
        <td>&nbsp;</td>
        <td style={{ textAlign:"right", "font-size": "medium",  "font-weight": "bold"}}>Date.: &nbsp;&nbsp;&nbsp;<u>25/12/2025</u> &nbsp;&nbsp;&nbsp;</td>
      </tr>
      <tr>
        <td colSpan="3" style={{"font-size": "medium",  "font-weight": "bold"}}>Name.: &nbsp;&nbsp;&nbsp;<u>Manjit Bharatkumar Vaghadiya</u> </td>
      </tr>
      <tr>
        <td colSpan="2" style={{textAlign:"right", "font-size": "medium",  "font-weight": "bold"}}>&nbsp;</td> 
        <td style={{textAlign:"right", "font-size": "medium",  "font-weight": "bold"}}>Shop / Flat No.: &nbsp;&nbsp;&nbsp;<u> 304</u>  &nbsp;&nbsp;&nbsp;</td> 
      </tr>
    </table>
  </div>}

  
  {1==2 && <div class="boxdsdf">
    <table>
      <tr>
        <td style={{"font-size": "medium",  "font-weight": "bold"}}> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This is to formally acknowledge the receipt of payment against the details mentioned below. The said amount has been duly received and recorded in the society accounts.</td>
      </tr>
    </table>
  </div>}

  
  {1==2 && <div class="boxsdfsd flex">
    <div class="half" >
      <table>
        <tr><td style={{"font-size": "medium",  "font-weight": "bold"}}>Desc</td><td style={{"font-size": "medium",  "font-weight": "bold"}}>Amount</td></tr>
        <tr><td>Maintenance</td><td> <u>&nbsp;&nbsp;&nbsp; 2500 &nbsp;&nbsp;&nbsp;</u> </td></tr>
        <tr><td>Entrance Fees</td><td><u>&nbsp;&nbsp;&nbsp; 1234 &nbsp;&nbsp;&nbsp;</u></td></tr>
        <tr><td>Share Donation</td><td><u>&nbsp;&nbsp;&nbsp; 1234 &nbsp;&nbsp;&nbsp;</u></td></tr>
        <tr><td>Development Donation</td><td><u>&nbsp;&nbsp;&nbsp; 1234 &nbsp;&nbsp;&nbsp;</u> </td></tr>
        <tr><td>Maintenance Deposit</td><td><u>&nbsp;&nbsp;&nbsp; 1234 &nbsp;&nbsp;&nbsp;</u></td></tr>
        <tr><td>Transfer Fees</td><td><u>&nbsp;&nbsp;&nbsp; 1234 &nbsp;&nbsp;&nbsp;</u></td></tr>
        <tr><td>Rental income</td><td><u>&nbsp;&nbsp;&nbsp; 1234 &nbsp;&nbsp;&nbsp;</u></td></tr>
        <tr><td>Other</td><td><u>&nbsp;&nbsp;&nbsp; 1234 &nbsp;&nbsp;&nbsp;</u></td></tr>
      </table>
    </div>

    
    <div class="half">
        <br/><br/><br/><br/>
         <center> <u>&nbsp;&nbsp;&nbsp; &nbsp;Cash&nbsp; / &nbsp;Cheque&nbsp; / &nbsp;Online&nbsp;  &nbsp;&nbsp;&nbsp;</u><br/><br/>
          Date.: <u>&nbsp;&nbsp;&nbsp; 25/12/2025 &nbsp;&nbsp;&nbsp;</u> <br/><br/>
          Bank.: <u>&nbsp;&nbsp;&nbsp; Bank of Maharashtra &nbsp;&nbsp;&nbsp;</u> <br/><br/>
          Branch.: <u>&nbsp;&nbsp;&nbsp; Tiruchirapalli &nbsp;&nbsp;&nbsp;</u> <br/><br/>
          Ref No.:<u>&nbsp;&nbsp;&nbsp; REF147R2R8Y9U5R001 &nbsp;&nbsp;&nbsp;</u> <br/><br/></center>
    </div>
  </div>}

  
  {1==2 && <div class="boxsdfs">
    <table>
      <tr>
        <td style={{textAlign:"right"}}> Chairman / Secretary</td>
        
      </tr>
      <tr>
        <td style={{textAlign:"right"}}> Signtature</td>
        </tr>
    </table>
  </div>}

</div>


</div>


        </div>

   }

      { !isListVisible &&
        <div className="form-container">
      <h2>Payment Entry</h2>
      <form onSubmit={handleSubmit} className="payment-form">
        {/* Flat No */}
        <div className="form-group">
          <label>Flat No</label>
          <Select
            options={flatNumbers}
            value={form.flat}
            onChange={(val) => setForm({ ...form, flat: val })}
            placeholder="Search flat..."
            className="select-box"
          />
        </div>

        {/* Amount */}
        <div className="form-group">
          <label>Amount</label>
          <input
            type="number"
            value={form.amount}
            onChange={handleAmountChange}
            placeholder="Enter amount"
          />
        </div>

        {/* Type */}
        <div className="form-group">
          <label>Type</label>
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="">Select Type</option>
            {typeOptions.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date */}
        <div className="form-group">
          <label>Date</label>
          <input type="date" name="date" value={form.date} onChange={handleChange} />
        </div>


         {/* Bank Name*/} 
        {form.type === "bank" && 
          
          <div className="form-group">
            <label>Bank Name</label>  
            <input
            type="text"
            name="bankName"
            value={form.bankName}
            onChange={handleChange}
            placeholder="Bank Name"
          />
          </div> }
            
            {/* Branch Name & Cheque No*/} 
            { form.type === "bank" && <div className="form-group">
              <label>Branch Name</label>  
              <input
              type="text"
              name="branchName"
              value={form.branchName}
              onChange={handleChange}
              placeholder="Branch Name"
            />
          </div>
            }

            { form.type === "bank" && <div className="form-group">
              <label>Cheque No</label>  
              <input
              type="text"
              name="chequeNo"
              value={form.chequeNo}
              onChange={handleChange}
              placeholder="Cheque No"
            />
          </div>
            }



        {/* Ref No */}
        <div className="form-group">
          <label>Reference No</label>
          <input
            type="text"
            name="refNo"
            value={form.refNo}
            onChange={handleChange}
            placeholder="Transaction / Ref No"
          />
        </div>

        {/* Purpose */}
        <div className="form-group">
          <label>Purpose</label>
          <select name="purpose" value={form.purpose} onChange={handleChange}>
            <option value="">Select Purpose</option>
            {purposeOptions.map((p) => (
              <option key={p.value} value={p.value}>
                {p.label}
              </option>
            ))}
          </select>
        </div>

        {/* Description */}
        <div className="form-group full-width">
          <label>Description</label>
          <textarea
            name="desc"
            value={form.desc}
            onChange={handleChange}
            placeholder="Description"
          />
        </div>

        <div className="form-group">
          <button type="submit"> {(paymentId === 0 ? "Insert" : "Update")} </button>
        </div>

        <div className="form-group">
          <button type="button" onClick={() => setIsListVisible(true)}>Cancel</button>
        </div>
      </form>
    </div> 
    }
    </>
  );
}


